import Vue from "vue";

import "./styles/quasar.scss";
import lang from "quasar/lang/it.js";
import "@quasar/extras/animate/fadeIn.css";
import "@quasar/extras/animate/fadeOut.css";
import "@quasar/extras/material-icons/material-icons.css";
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QAvatar,
  QFooter,
  QInput,
  QForm,
  QSpace,
  QBtnDropdown,
  QCard,
  QCardSection,
  QTable,
  QTr,
  QTd,
  QDialog,
  QCardActions,
  QField,
  QSelect,
  QOptionGroup,
  QLinearProgress,
  QInnerLoading,
  QSpinner,
  QEditor,
  QSeparator,
  QExpansionItem,
  QPopupEdit,
  QCheckbox,
  QBreadcrumbs,
  QBreadcrumbsEl,
  QVirtualScroll,
  QTab,
  QTabs,
  QTabPanel,
  QTabPanels,
  QMenu,
  QDate,
  QPopupProxy,
  QBanner,
  Notify,
  Dialog,
  Ripple,
  Loading,
} from "quasar";

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QAvatar,
    QFooter,
    QInput,
    QForm,
    QSpace,
    QBtnDropdown,
    QCard,
    QCardSection,
    QTable,
    QTr,
    QTd,
    QDialog,
    QCardActions,
    QField,
    QSelect,
    QOptionGroup,
    QLinearProgress,
    QInnerLoading,
    QSpinner,
    QEditor,
    QSeparator,
    QExpansionItem,
    QPopupEdit,
    QCheckbox,
    QBreadcrumbs,
    QBreadcrumbsEl,
    QVirtualScroll,
    QTab,
    QTabs,
    QTabPanel,
    QTabPanels,
    QMenu,
    QDate,
    QPopupProxy,
    QBanner,
  },
  directives: {
    Ripple,
  },
  plugins: {
    Notify,
    Dialog,
    Loading,
  },
  lang: lang,
});
